import {useQuery} from '@apollo/client';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {sanitiseProductType} from '../../../utils/sanitiseProductType';
import validateUUID from '../../../utils/validateUUID';
import {BUILDER_CONTRIBUTE_POTS} from '../builderPotQueries';
import {reccNonEditable} from '../CreateBuilder/BuilderSourceDestination/CreateBuilderFooter';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  BuilderContributePots,
  BuilderContributePotsVariables,
} from '../../../schema-types/BuilderContributePots';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const useContributionPotsQuery = (): {
  sourcePots: BuilderPot[];
  destinationPots: BuilderPot[];
} => {
  const {builderDetails, builderReviewId} = useBuilderContext();
  const {values} = useAutoForm<builderFieldsType>();
  const contactId = values.contact ? validateUUID(values.contact) || null : null;
  const isNonEditable = !!reccNonEditable(builderDetails);

  const {data: potsData} = useQuery<
    BuilderContributePots,
    BuilderContributePotsVariables
  >(BUILDER_CONTRIBUTE_POTS, {
    variables: {
      reviewId: validateUUID(builderReviewId)!,
      contactId,
      potType: sanitiseProductType(values.mainPlanType) ?? '',
    },
    skip:
      isNonEditable ||
      values.planAction !== OVRecommendActionEnum.CONTRIBUTE ||
      !values.mainPlanType ||
      !validateUUID(builderReviewId),
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  if (isNonEditable) {
    const savedSource = builderDetails?.contribute?.sourcePot;
    const savedDestination = builderDetails?.contribute?.destinationPot;
    return {
      sourcePots: savedSource ? [savedSource] : [],
      destinationPots: savedDestination ? [savedDestination] : [],
    };
  }

  return {
    sourcePots: potsData?.contributePots?.sources ?? [],
    destinationPots: potsData?.contributePots?.destinations ?? [],
  };
};
